<template>
  <div class="option">
    <div class="checkbox" :class="{ checked: props.isSelected }" />
    <img
      :src="getTokenIconUrl(props.label.split('/')[0])"
      width="22"
      height="22"
      :alt="props.feed"
      class="icon"
    />
    {{ props.label }}
  </div>
</template>

<script setup>
const props = defineProps({
  label: String,
  isSelected: Boolean
})
</script>

<style lang="scss" scoped>
.option {
  padding: 14px 20px;
  letter-spacing: 0.32px;
  font-weight: 500;
  color: var(--Text, #000000);
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 100%;
  cursor: pointer;
}

.checkbox {
  border-radius: 4px;
  border: 1px solid var(--field-stroke-hover, rgba(255, 255, 255, 0.4));
  width: 18px;
  height: 18px;
  margin-right: 5px;

  &.checked {
    background: url(/images/tick-white.svg) no-repeat center center
      var(--CTA, #3d6ef6);
  }
}

.icon {
  border-radius: 50%;
}
</style>
